'use strict';

import * as angular from 'angular';
var app = angular.module('noc.monitoring', []);

app.factory('ZabbixIssueFactory', require('./pages/alarm/zabbixIssueFactory'));
app.factory('ZabbixOverviewFactory', require('./pages/alarm/zabbixOverviewFactory'));

app.service('MonitoringStoreService', require('./store/monitoringStoreService'));


app.directive('trainCanvas', require('./directives/trainCanvasDirective'));


export default app;